import {getTranslation} from "../helpers/helpers";
import utils from "../utils/utils.js";
import FileUpload from "./dropzone";
import {
    renderCustomerPopupCloudErrorHtml,
    requestCustomerPopupCloudHtml,
} from "../helpers/customer-popup-cloud";
import {
    renderLeadPopupCloudErrorHtml,
} from "../helpers/lead-info-popup-cloud";
import {
    renderBookingPopupCloudErrorHtml,
    requestCoordinatedBookingPopupCloudHtml,
} from "../helpers/booking-popup-cloud";
import {
    renderSupportTicketPopupCloudErrorHtml,
    requestSupportTicketPopupCloudHtml,
} from "../helpers/support-ticket-popup-cloud";
import {requestCoordinatedLeadPopupCloudHtml, requestFreshLeadPopupCloudHtml} from "../helpers/lead-popup-request";
import {shouldRequestPopupContent} from "./popup-content-state";
import {registerPopupReload, rememberPopupContent, popupNeedsRefresh, schedulePopupRefresh} from "./popup-refresh";

import {positionPopupCloseButton} from "./popup-close-button";

function replacePopupHtml(selector, html) {
    // Fancybox owns this button and its close handler; keep the same node when cloud content changes.
    const closeButton = selector.children('button.carousel__button.is-close')
        .add(selector.children('.ng-popup__header').children('button.carousel__button.is-close')).detach();
    selector.html(html).append(closeButton);
    positionPopupCloseButton(selector.get(0));
}

export class popupContent {
    spinner = $('.load-wrapper');

    constructor(action, elem) {
        this.action = action;
        this.trigger = '[data-' + elem + ']';
        this.elem = elem;
        this.supportTicketPopupRequests = new WeakSet();
        this.eventHandlers();
    }

    eventHandlers() {
        $(document.body).on('popup_html_loaded', this.initFileUpload.bind(this));

        //Events
      $(document.body).on('click', this.trigger, this.ajaxContentPopup.bind(this));
    }

    initFileUpload(e, action, selector) {
        // Ignore popup loads that were triggered by other popupContent instances
        if (action !== this.action) return;
        if (action !== 'wl_ajax_support_ticket_popup') return;

        // Only initialize if the loaded popup actually contains a dropzone.
        // Both selectors on purpose — see the note in components/dropzone.js:
        // the class is what production still emits until the cloud branch ships.
        if (!selector || $(selector).find('[data-dropzone], .dropzone').length === 0) return;

        // Ensure we only create one FileUpload instance (prevents duplicate event bindings)
        if (!window.__fileUploadInstance) {
            window.__fileUploadInstance = new FileUpload(selector);
        } else {
            window.__fileUploadInstance.initDropzone(selector);
        }
    }


    ifContentExists(selector, find) {
        return $(selector).find(find).length;
    }

    resetStaleSupportTicketPopup(selector) {
        if (this.action !== 'wl_ajax_support_ticket_popup') return;

        const reloadRequired = selector.find(
            '[data-form-support-ticket][data-support-ticket-reload-required="1"], [data-files][data-reload-required="1"]'
        ).length > 0;
        if (!reloadRequired) return;

        if (window.__fileUploadInstance) {
            window.__fileUploadInstance.destroyDropZones(selector);
        }
        replacePopupHtml(selector, '');
    }

    ajaxContentPopup(e) {
        let _this = $(e.currentTarget);
        let data = {..._this.data(this.elem)};
        // Escape special characters in ID for jQuery selector
        const popupSelector = '#' + CSS.escape(data.booking_selector);
        let selector = this.action === 'wl_ajax_booking_popup'
            ? _this.siblings(popupSelector).first()
            : $();
        if (!selector.length) {
            selector = $(popupSelector).first();
        }
        data.action = this.action;
        data._wpnonce = utils.get_nonce();
        if (this.action !== 'wl_ajax_lead_info_popup') data.post_id = utils.get_post_id();
        registerPopupReload(selector, () => this.requestHtml(selector, data), () => {
            $(document.body).trigger('popup_html_loaded', [this.action, selector]);
        });
        if (popupNeedsRefresh(selector)) {
            schedulePopupRefresh();
            return;
        }
        this.resetStaleSupportTicketPopup(selector);
        // Check if content already loaded (form for most popups, .lead-info-information for lead info)
        const shouldRequestContent = shouldRequestPopupContent({
            alwaysRefresh: this.action === 'wl_ajax_booking_popup' || this.action === 'wl_ajax_lead_info_popup',
            hasForm: this.ifContentExists(selector, 'form') !== 0,
            hasLeadInfo: this.ifContentExists(selector, '.lead-info-information') !== 0,
        });
        if (!shouldRequestContent) return;
        data.action = this.action;
        data._wpnonce = utils.get_nonce();
        const actions = ['wl_ajax_lead_info_popup'];
        if (actions.indexOf(this.action) === -1) data.post_id = utils.get_post_id();
        const action = this.action;
        if (this.action === 'wl_ajax_customer_popup') {
            this.ajaxCustomerPopupContent(selector, data, action);
            return;
        }

        if (this.action === 'wl_ajax_lead_info_popup') {
            this.ajaxLeadInfoPopupContent(selector, data, action);
            return;
        }

        if (this.action === 'wl_ajax_booking_popup') {
            this.ajaxBookingPopupContent(selector, data, action);
            return;
        }

        if (this.action === 'wl_ajax_support_ticket_popup') {
            this.ajaxSupportTicketPopupContent(selector, data, action);
            return;
        }

        $.ajax({
            type: "POST",
            url: utils.get_ajax_url(),
            data: data,
            success: function (result) {
                $(selector).html(result);
                rememberPopupContent(selector);
            },
            complete: function () {
                // Provide context so only the relevant popup handlers run
                $(document.body).trigger("popup_html_loaded", [action, selector]);
            },
        });
    }

    requestHtml(selector, data) {
        if (this.action === 'wl_ajax_customer_popup') return requestCustomerPopupCloudHtml(data);
        if (this.action === 'wl_ajax_lead_info_popup') return requestFreshLeadPopupCloudHtml(selector[0], data);
        if (this.action === 'wl_ajax_booking_popup') return requestCoordinatedBookingPopupCloudHtml(selector[0], data).promise;
        if (this.action === 'wl_ajax_support_ticket_popup') return requestSupportTicketPopupCloudHtml(data);
        return Promise.resolve($.ajax({type: 'POST', url: utils.get_ajax_url(), data: {...data, _wpnonce: utils.get_nonce()}}))
            .then(html => {
                if (typeof html !== 'string' || !html.trim()) throw new Error('Invalid popup response');
                return html;
            });
    }

    ajaxCustomerPopupContent(selector, data, action) {
        requestCustomerPopupCloudHtml(data)
            .then(function (html) {
                replacePopupHtml(selector, html);
                rememberPopupContent(selector);
            })
            .catch(function (error) {
                void error;
                replacePopupHtml(selector, renderCustomerPopupCloudErrorHtml());
            })
            .finally(function () {
                $(document.body).trigger("popup_html_loaded", [action, selector]);
            });
    }

    ajaxLeadInfoPopupContent(selector, data, action) {
        const popupElement = selector.get(0);
        if (!popupElement) return;
        const request = requestCoordinatedLeadPopupCloudHtml(popupElement, data);
        if (!request.started) return;

        request.promise
            .then(function (html) {
                $(selector).html(html);
                rememberPopupContent(selector);
            })
            .catch(function (error) {
                void error;
                $(selector).html(renderLeadPopupCloudErrorHtml());
            })
            .finally(function () {
                $(document.body).trigger("popup_html_loaded", [action, selector]);
            });
    }

    ajaxBookingPopupContent(selector, data, action) {
        const popupElement = selector.get(0);
        if (!popupElement) return;

        const request = requestCoordinatedBookingPopupCloudHtml(popupElement, data);
        if (!request.started) return;

        $(selector).html(this.renderPopupLoaderHtml('booking-popup-loader'));

        request.promise
            .then(function (html) {
                $(selector).html(html);
                rememberPopupContent(selector);
            })
            .catch(function (error) {
                void error;
                $(selector).html(renderBookingPopupCloudErrorHtml());
            })
            .finally(() => {
                $(document.body).trigger("popup_html_loaded", [action, selector]);
            });
    }

    ajaxSupportTicketPopupContent(selector, data, action) {
        const popupElement = selector.get(0);
        if (!popupElement || this.supportTicketPopupRequests.has(popupElement)) return;

        this.supportTicketPopupRequests.add(popupElement);
        replacePopupHtml(selector, this.renderPopupLoaderHtml('support-ticket-popup-loader'));

        requestSupportTicketPopupCloudHtml(data)
            .then(function (html) {
                replacePopupHtml(selector, html);
                rememberPopupContent(selector);
            })
            .catch(function (error) {
                replacePopupHtml(selector, renderSupportTicketPopupCloudErrorHtml(error));
            })
            .finally(() => {
                this.supportTicketPopupRequests.delete(popupElement);
                $(document.body).trigger("popup_html_loaded", [action, selector]);
            });
    }

    renderPopupLoaderHtml(loaderClass = '') {
        return `<div class="load-wrapper load-wrapper--inline loading-posts ${loaderClass}">
            <div class="loader--moving-l4 loader--moving-logo loader--moving-logo--smooth" role="status" aria-label="${getTranslation('loading')}">
                <span class="loader--moving-logo__glow" aria-hidden="true"></span>
                <svg class="loader--moving-logo__svg" viewBox="0 0 192.3 274.6" aria-hidden="true" focusable="false">
                    <path class="loader-piece loader-piece--1" d="M63.7,244.1l31.8,30.5l96.7-91.2c0,0-0.2-26.9,0-60.3L63.7,244.1z"></path>
                    <polygon class="loader-piece loader-piece--2" points="31.4,213.1 63.7,244.1 192.3,123.1 192.3,62.5"></polygon>
                    <polygon class="loader-piece loader-piece--3" points="0,183.1 31.4,213.1 192.3,62.5 192.3,0 127.5,62.5"></polygon>
                    <polygon class="loader-piece loader-piece--4" points="0,62.5 0,183.1 127.5,62.5"></polygon>
                </svg>
            </div>
        </div>`;
    }
}
